var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.442,
    height: 64.199,
    viewBox: "0 0 52.442 64.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_49",
    "data-name": "Komponente 10 \\u2013 49",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choices",
    transform: "translate(-47.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35514",
    "data-name": "Gruppe 35514",
    transform: "translate(53.444 9.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35513",
    "data-name": "Gruppe 35513",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46802",
    "data-name": "Pfad 46802",
    d: "M105.753,80.167a1,1,0,0,0-1,1,2.2,2.2,0,1,1-2.2-2.2,1,1,0,1,0,0-2,4.209,4.209,0,1,0,4.209,4.209A1,1,0,0,0,105.753,80.167Z",
    transform: "translate(-98.338 -76.96)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35516",
    "data-name": "Gruppe 35516",
    transform: "translate(53.444 21.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35515",
    "data-name": "Gruppe 35515",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46803",
    "data-name": "Pfad 46803",
    d: "M105.753,174.229a1,1,0,0,0-1,1,2.2,2.2,0,1,1-2.2-2.2,1,1,0,1,0,0-2,4.209,4.209,0,1,0,4.209,4.209A1,1,0,0,0,105.753,174.229Z",
    transform: "translate(-98.338 -171.022)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35518",
    "data-name": "Gruppe 35518",
    transform: "translate(64.133 26.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35517",
    "data-name": "Gruppe 35517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46804",
    "data-name": "Pfad 46804",
    d: "M192.333,213.779h-7.482a1,1,0,1,0,0,2h7.482a1,1,0,1,0,0-2Z",
    transform: "translate(-183.849 -213.779)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35520",
    "data-name": "Gruppe 35520",
    transform: "translate(64.133 22.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35519",
    "data-name": "Gruppe 35519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46805",
    "data-name": "Pfad 46805",
    d: "M192.333,179.574h-7.482a1,1,0,0,0,0,2h7.482a1,1,0,0,0,0-2Z",
    transform: "translate(-183.849 -179.574)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35522",
    "data-name": "Gruppe 35522",
    transform: "translate(64.133 38.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35521",
    "data-name": "Gruppe 35521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46806",
    "data-name": "Pfad 46806",
    d: "M190.2,307.841h-5.344a1,1,0,1,0,0,2H190.2a1,1,0,1,0,0-2Z",
    transform: "translate(-183.849 -307.841)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35524",
    "data-name": "Gruppe 35524",
    transform: "translate(64.133 34.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35523",
    "data-name": "Gruppe 35523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46807",
    "data-name": "Pfad 46807",
    d: "M192.333,273.637h-7.482a1,1,0,1,0,0,2h7.482a1,1,0,1,0,0-2Z",
    transform: "translate(-183.849 -273.637)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35526",
    "data-name": "Gruppe 35526",
    transform: "translate(64.133 14.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35525",
    "data-name": "Gruppe 35525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46808",
    "data-name": "Pfad 46808",
    d: "M201.953,119.716h-17.1a1,1,0,1,0,0,2h17.1a1,1,0,0,0,0-2Z",
    transform: "translate(-183.849 -119.716)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35528",
    "data-name": "Gruppe 35528",
    transform: "translate(64.133 10.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35527",
    "data-name": "Gruppe 35527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46809",
    "data-name": "Pfad 46809",
    d: "M197.678,85.511H184.851a1,1,0,1,0,0,2h12.827a1,1,0,1,0,0-2Z",
    transform: "translate(-183.849 -85.511)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35530",
    "data-name": "Gruppe 35530",
    transform: "translate(53.444 33.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35529",
    "data-name": "Gruppe 35529",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46810",
    "data-name": "Pfad 46810",
    d: "M105.753,268.292a1,1,0,0,0-1,1,2.2,2.2,0,1,1-2.2-2.2,1,1,0,0,0,0-2,4.209,4.209,0,1,0,4.209,4.209A1,1,0,0,0,105.753,268.292Z",
    transform: "translate(-98.338 -265.085)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35532",
    "data-name": "Gruppe 35532",
    transform: "translate(47.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35531",
    "data-name": "Gruppe 35531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46811",
    "data-name": "Pfad 46811",
    d: "M86.513,0H50.171a3.143,3.143,0,0,0-3.14,3.14V48.033a3.143,3.143,0,0,0,3.14,3.14H68.342a1,1,0,1,0,0-2H50.171a1.137,1.137,0,0,1-1.136-1.136V3.14A1.137,1.137,0,0,1,50.171,2H86.513A1.137,1.137,0,0,1,87.649,3.14V36.276a1,1,0,1,0,2,0V3.14A3.144,3.144,0,0,0,86.513,0Z",
    transform: "translate(-47.031)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35534",
    "data-name": "Gruppe 35534",
    transform: "translate(71.083 22.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35533",
    "data-name": "Gruppe 35533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46812",
    "data-name": "Pfad 46812",
    d: "M264.342,197.767a3.7,3.7,0,0,0-2.6.73A3.65,3.65,0,0,0,259,196.7a3.7,3.7,0,0,0-2.6.73,3.65,3.65,0,0,0-2.745-1.8,3.7,3.7,0,0,0-2.046.384V183.252a3.675,3.675,0,0,0-4.05-3.656,3.791,3.791,0,0,0-3.3,3.808V196.2l-2.946,2.946a6.307,6.307,0,0,0-1.69,5.941l2.236,9.5a8.452,8.452,0,0,0,8.259,6.541h9.038a8.494,8.494,0,0,0,8.484-8.484V201.576A3.791,3.791,0,0,0,264.342,197.767Zm1.295,14.879a6.487,6.487,0,0,1-6.48,6.48h-9.038a6.455,6.455,0,0,1-6.308-5l-2.236-9.5a4.315,4.315,0,0,1,1.156-4.065l1.529-1.529v3.46a1,1,0,0,0,2,0V183.4a1.772,1.772,0,0,1,1.494-1.814,1.671,1.671,0,0,1,1.846,1.661v17.637a1,1,0,0,0,2,0v-1.6a1.671,1.671,0,0,1,1.846-1.661,1.772,1.772,0,0,1,1.495,1.814v2.52a1,1,0,1,0,2,0v-1.6a1.671,1.671,0,0,1,1.846-1.661,1.772,1.772,0,0,1,1.495,1.814v2.52a1,1,0,1,0,2,0v-1.6a1.671,1.671,0,0,1,1.846-1.661,1.772,1.772,0,0,1,1.494,1.814v11.071Z",
    transform: "translate(-239.452 -179.578)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro9);
export default __webpack_public_path__ + "static/media/Pro9.a5eefd313947316bfdd8e06b1497b082.svg";
export { ForwardRef as ReactComponent };